<template>
  <div style="background: #f8fafc; min-height: 100vh; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
    <ServicesServiceHero
      title="AWS Cloud Architect & Developer"
      description="Transform your business with scalable, secure, and cost-effective cloud architecture solutions"
      icon="☁️"
      gradient="aws-cloud-architect"
    />

    <!-- Main Content -->
    <div class="container" style="max-width: 1000px;">
      <div class="row">
        <div class="col-md-12">
          <div class="service-main-card">
            <h2 style="color: #1a202c; font-weight: 700; margin-bottom: 24px; font-size: 2.2rem;">Elevate Your Business to the Cloud ☁️</h2>
            <p style="color: #4a5568; line-height: 1.7; font-size: 1.1rem; margin-bottom: 40px;">Ready to unlock the full potential of cloud computing? As an AWS Cloud Architect and Developer, I transform businesses by designing and implementing robust, scalable, and secure cloud infrastructures that drive growth and innovation.</p>
            
            <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; font-size: 1.8rem;">What Makes a Great Cloud Architect?</h3>
            <div class="row">
              <div class="col-md-6 mb-4">
                <div :style="{ background: '#f7fafc', padding: '24px', borderRadius: '12px', borderLeft: `4px solid var(--aws-cloud-architect-start)`, height: '100%' }">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px">🎯 Strategic Visionary</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6">Aligns technology solutions with your business objectives</p>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div :style="{ background: '#f7fafc', padding: '24px', borderRadius: '12px', borderLeft: `4px solid var(--aws-cloud-architect-start)`, height: '100%' }">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px">🏗️ Master Builder</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6">Designs resilient architectures that scale with your growth</p>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div :style="{ background: '#f7fafc', padding: '24px', borderRadius: '12px', borderLeft: `4px solid var(--aws-cloud-architect-start)`, height: '100%' }">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px">🔒 Security Guardian</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6">Implements best practices to protect your valuable data</p>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div :style="{ background: '#f7fafc', padding: '24px', borderRadius: '12px', borderLeft: `4px solid var(--aws-cloud-architect-start)`, height: '100%' }">
                  <h4 style="color: #1a202c; font-weight: 600; margin-bottom: 12px">💰 Cost Optimizer</h4>
                  <p style="color: #4a5568; margin: 0; line-height: 1.6">Ensures you get maximum value from your cloud investment</p>
                </div>
              </div>
            </div>

            <h3 style="color: #1a202c; font-weight: 600; margin-bottom: 30px; margin-top: 50px; font-size: 1.8rem;">Core Services & Expertise</h3>
            
            <div class="row">
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🏛️ Architecture Design & Planning</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>Solution Architecture</li>
                    <li>Migration Planning</li>
                    <li>Scalability Design</li>
                    <li>Multi-Region Setup</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🔧 Implementation & Development</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>Infrastructure as Code</li>
                    <li>Serverless Solutions</li>
                    <li>Container Orchestration</li>
                    <li>Database Architecture</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">🛡️ Security & Compliance</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>Identity & Access Management</li>
                    <li>Network Security</li>
                    <li>Data Encryption</li>
                    <li>Compliance Framework</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-6 mb-4">
                <div style="background: linear-gradient(135deg, #ff9500 0%, #ff6b00 100%); color: white; padding: 32px; border-radius: 16px; height: 100%;">
                  <h4 style="font-weight: 700; margin-bottom: 16px; font-size: 1.3rem;">📊 Monitoring & Optimization</h4>
                  <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
                    <li>CloudWatch Integration</li>
                    <li>Performance Tuning</li>
                    <li>Cost Management</li>
                    <li>Disaster Recovery</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Pricing Section -->
            <div style="background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); padding: 40px; border-radius: 16px; margin-top: 50px; border-left: 4px solid #3b82f6; text-align: center;">
              <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 16px; font-size: 1.8rem;">Transparent Pricing</h3>
              <p style="color: #4a5568; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px; max-width: 700px; margin-left: auto; margin-right: auto;">
                Standard rate of <strong style="color: #1a202c; font-size: 1.2rem;">$225/hour</strong> for consulting and implementation. Volume discounts and retainer packages available.
              </p>
              <NuxtLink to="/services/pricing" style="display: inline-block; background: #3b82f6; color: white; padding: 14px 32px; border-radius: 8px; font-weight: 600; text-decoration: none; font-size: 1.05rem; transition: background 0.2s;">
                View Full Pricing Details
              </NuxtLink>
            </div>

            <div :style="{ background: `linear-gradient(135deg, var(--aws-cloud-architect-start) 0%, var(--aws-cloud-architect-end) 100%)`, color: 'white', padding: '40px', borderRadius: '16px', marginTop: '50px', textAlign: 'center' }">
              <h3 style="font-weight: 700; margin-bottom: 20px; font-size: 1.8rem;">Ready to Transform Your Business?</h3>
              <p style="font-size: 1.1rem; opacity: 0.95; line-height: 1.6; margin-bottom: 30px;">Whether you're a startup building your first cloud-native application or an enterprise planning comprehensive digital transformation, I'm here to guide you every step of the way.</p>
              <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
                <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                  <h4 style="font-weight: 600; margin-bottom: 12px;">🚀 Startups</h4>
                  <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Building scalable foundations</p>
                </div>
                <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                  <h4 style="font-weight: 600; margin-bottom: 12px;">🏢 Enterprises</h4>
                  <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Digital transformation</p>
                </div>
                <div style="background: rgba(255,255,255,0.2); padding: 20px; border-radius: 12px; backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.3); flex: 1; min-width: 200px; max-width: 250px;">
                  <h4 style="font-weight: 600; margin-bottom: 12px;">📈 Growing Companies</h4>
                  <p style="margin: 0; font-size: 0.95rem; opacity: 0.9;">Infrastructure modernization</p>
                </div>
              </div>
              <p style="margin-top: 30px; margin-bottom: 0; font-style: italic; opacity: 0.9;">Your journey to cloud excellence starts here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
useHead({
  title: 'AWS Cloud Architect & Developer | Geek Cafe',
  meta: [
    { name: 'description', content: 'Transform your business with scalable, secure, and cost-effective cloud architecture solutions. Expert AWS cloud architect and developer services.' }
  ]
})
</script>

<style scoped src="@/assets/css/service-detail-card.css"></style>
